export const ENVIRONMENTAL_VARIABLES = window.ENVIRONMENTAL_VARIABLES;
export const getEnvironmentalVariables = () => window.ENVIRONMENTAL_VARIABLES;
